import React from 'react'
import { Card, Carousel, CarouselItem, Col, Row } from 'react-bootstrap'

const IndustrialEnvironments = () => {

  return (
    <>
        <Card className='no-border rounded-0 container text-center'>
            <Card.Body>
                <Card.Title className='industrial-modeling-title'> 産業環境におけるデジタルツイン </Card.Title>
                <Card.Text className='industrial-environment-text text-left'>
                デジタルツインは、没入型テクノロジーの最も効果的でROIの高い用途の1つであり、多くの産業企業がAR/VRプログラムへの導入として利用しています。デジタルツインは、個々の部品、複雑なワークフロー、システム全体、さらには物理的な世界にまだ存在しない研究開発中の製品についても作成することができます。
                <br />
                <br />
                デジタルツインは、以下のような企業に貢献しています。
                </Card.Text>
            </Card.Body>
            <Row>
                <Col xs={{span:12, offset:0}} md={{span:4, offset:2}} className="py-2 py-md-4">
                    <Row>
                        <Col xs={{span:2, offset:0}} className="text-end">
                            <Card.Img className='photography-icon align-self-end' src={"/assets/icons/dt_001.png"} alt="" />
                        </Col>
                        <Col xs={{span:8, offset:0}} className="text-start">
                            <Card.Text> ・自動化されたシステムの監視と最適化 </Card.Text>
                        </Col>
                    </Row>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:4, offset:0}} className="py-2 py-md-4">
                    <Row>
                        <Col xs={{span:2, offset:0}} className="text-end">
                            <Card.Img className='photography-icon align-self-end' src={"/assets/icons/dt_002.png"} alt="" />
                        </Col>
                        <Col xs={{span:8, offset:0}} className="text-start">
                            <Card.Text> ・災害対策の計画 </Card.Text>
                        </Col>
                    </Row>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:4, offset:2}} className="py-2 py-md-4">
                    <Row>
                        <Col xs={{span:2, offset:0}} className="text-end">
                            <Card.Img className='photography-icon align-self-end' src={"/assets/icons/dt_003.png"} alt="" />
                        </Col>
                        <Col xs={{span:8, offset:0}} className="text-start">
                            <Card.Text> ・開発中の製品のテスト </Card.Text>
                        </Col>
                    </Row>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:4, offset:0}} className="py-2 py-md-4">
                    <Row>
                        <Col xs={{span:2, offset:0}} className="text-end">
                            <Card.Img className='photography-icon align-self-end' src={"/assets/icons/dt_004.png"} alt="" />
                        </Col>
                        <Col xs={{span:8, offset:0}} className="text-start">
                            <Card.Text> ・サプライチェーンの課題管理 </Card.Text>
                        </Col>
                    </Row>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:4, offset:2}} className="py-2 py-md-4">
                    <Row>
                        <Col xs={{span:2, offset:0}} className="text-end">
                            <Card.Img className='photography-icon align-self-end' src={"/assets/icons/dt_005.png"} alt="" />
                        </Col>
                        <Col xs={{span:8, offset:0}} className="text-start">
                            <Card.Text> ・変更実装前の製造現場シミュレーション </Card.Text>
                        </Col>
                    </Row>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:4, offset:0}} className="py-2 py-md-4">
                    <Row>
                        <Col xs={{span:2, offset:0}} className="text-end">
                            <Card.Img className='photography-icon align-self-end' src={"/assets/icons/dt_006.png"} alt="" />
                        </Col>
                        <Col xs={{span:8, offset:0}} className="text-start">
                            <Card.Text> ・保守点検の計画 </Card.Text>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row>
                <Col xs={{span:12, offset:0}} md={{span:6, offset:3}} className="py-md-5 my-md-3 py-4">
                <Card.Img className='' src={"/assets/digital-twin/industrial/industrial-banner.jpg"} />
                </Col>
            </Row>

        </Card>
        <Card className='no-border rounded-0 container my-md-0 py-md-0 py-5 my-4'>
            <Row>
                <Col>
                <Carousel className='industrial-carousel' interval={null}>
                <CarouselItem>
                        <Row>

                        <Col md={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 left-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={"/assets/digital-twin/industrial/ind_003_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card '>
                                    <Card.Img className='main-slider-image' src={"/assets/digital-twin/industrial/ind_001.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 現実世界の作業現場 <br /> （参考写真）</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card '>
                                    <Card.Img className='main-slider-image' src={"/assets/digital-twin/industrial/ind_001_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 仮想空間（VR）の作業現場 <br /> （3Dモデルのレンダリング画像）</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col md={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 right-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={"/assets/digital-twin/industrial/ind_002.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row>

                        <Col md={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 left-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={"/assets/digital-twin/industrial/ind_001_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card'>
                                    <Card.Img className='main-slider-image' src={"/assets/digital-twin/industrial/ind_002.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 現実世界の作業現場 <br /> （参考写真）</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card '>
                                    <Card.Img className='main-slider-image' src={"/assets/digital-twin/industrial/ind_002_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 仮想空間（VR）の作業現場 <br /> （3Dモデルのレンダリング画像）</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col md={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 right-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={"/assets/digital-twin/industrial/ind_003.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row>
                            <Col md={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 left-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={"/assets/digital-twin/industrial/ind_002_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card '>
                                    <Card.Img className='main-slider-image' src={"/assets/digital-twin/industrial/ind_003.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 現実世界の作業現場 <br /> （参考写真）</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card'>
                                    <Card.Img className='main-slider-image' src={"/assets/digital-twin/industrial/ind_003_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 仮想空間（VR）の作業現場 <br /> （3Dモデルのレンダリング画像）</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col md={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 right-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={"/assets/digital-twin/industrial/ind_001.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                </Carousel>
                </Col>
            </Row>

        </Card>
      
    </>
  )
}

export default IndustrialEnvironments
